export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[520px] md:min-h-[600px] flex items-center bg-background-50 overflow-hidden pt-16">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40 pointer-events-none"></div>
      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 bg-accent-100 text-accent-700 text-xs font-medium px-3 py-1.5 rounded-full mb-4">
              <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center"></i>
              实时更新中
            </span>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-900 leading-tight mb-3">
              每日大赛mrds
              <span className="block text-primary-500 text-xl md:text-3xl lg:text-3xl mt-1">热门话题与每日爆料平台</span>
            </h1>
            <p className="text-sm md:text-base text-foreground-500 font-medium mb-4">
              每日新瓜不断，榜单揭晓一站掌握
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-xl lg:max-w-none">
              每日大赛mrds是全网最受关注的<strong className="text-foreground-900">mrds热门话题</strong>聚合地。每日更新<strong className="text-foreground-900">mrds每日爆料</strong>与<strong className="text-foreground-900">每日大赛新瓜</strong>，实时揭晓<strong className="text-foreground-900">mrds榜单揭晓</strong>排名，深度追踪<strong className="text-foreground-900">黑料</strong>内幕，更精选<strong className="text-foreground-900">擦边搞笑</strong>内容让你开怀一笑。无论你是吃瓜达人还是娱乐爱好者，这里的<strong className="text-foreground-900">榜单看点</strong>每天都有新惊喜，<strong className="text-foreground-900">大赛每日更新</strong>让你不错过任何一个爆款话题。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-6">
              <div className="text-center">
                <div className="text-lg md:text-xl font-heading text-primary-500">1500+</div>
                <div className="text-xs text-foreground-400">今日更新话题</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-heading text-accent-500">8.6万</div>
                <div className="text-xs text-foreground-400">累计爆料条目</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-heading text-secondary-600">24h</div>
                <div className="text-xs text-foreground-400">全天候滚动更新</div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#ranking" className="inline-flex items-center gap-2 whitespace-nowrap bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer w-full sm:w-auto justify-center">
                <i className="ri-trophy-line w-4 h-4 flex items-center justify-center"></i>
                查看热门榜单
              </a>
              <a href="#about" className="inline-flex items-center gap-2 whitespace-nowrap bg-secondary-100 text-secondary-700 px-6 py-3 rounded-full text-sm font-medium hover:bg-secondary-200 transition-colors duration-200 cursor-pointer w-full sm:w-auto justify-center">
                <i className="ri-information-line w-4 h-4 flex items-center justify-center"></i>
                了解更多
              </a>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] md:w-[380px] md:h-[380px] lg:w-[420px] lg:h-[420px] rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20of%20trending%20topics%20and%20social%20media%20buzz%20warm%20orange%20coral%20and%20amber%20gradient%20tones%20dynamic%20flowing%20shapes%20floating%20speech%20bubbles%20fire%20icons%20hot%20topic%20visualization%20modern%20minimalist%20clean%20design%20digital%20art%20style%20soft%20lighting%20harmonious%20composition%20editorial%20quality&width=840&height=840&seq=mrds-hero-main&orientation=squarish"
                alt="每日大赛mrds热门话题与每日爆料"
                className="w-full h-full object-cover object-top"
                onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-500/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}